// Keep the existing update date with the title, without changing policy copy.
const formatPolicyDate = () => {
  const page = document.querySelector('.shopify-policy__container, .zetech-clear-page');
  if (!page || page.querySelector('.shopify-policy__updated')) return;

  const body = page.querySelector('.shopify-policy__body .rte, .rte rte-formatter');
  const firstParagraph = body?.querySelector('p');
  const heading = page.querySelector('.shopify-policy__title, .text-block:has(h1)');
  body?.querySelectorAll('p > strong').forEach((strong) => {
    let before = strong.previousSibling;
    let after = strong.nextSibling;
    while (before?.nodeType === Node.TEXT_NODE && !before.textContent.trim()) before = before.previousSibling;
    while (after?.nodeType === Node.TEXT_NODE && !after.textContent.trim()) after = after.nextSibling;
    if ((!before || before.nodeName === 'BR') && after?.nodeName === 'BR') {
      strong.classList.add('zetech-policy-heading');
    }
  });
  if (!heading || !firstParagraph || !/^Last updated\s*:/i.test(firstParagraph.textContent.trim())) return;

  firstParagraph.classList.add('shopify-policy__updated');
  heading.after(firstParagraph);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', formatPolicyDate, { once: true });
} else {
  formatPolicyDate();
}

document.addEventListener('shopify:section:load', formatPolicyDate);
